import { useQuery } from '@tanstack/react-query';
import { useEntity } from '@/hooks/useEntity';
import { listInvoices } from '../api/billing.api';
import { billingKeys } from './billing.keys';

/** The native billing history for the acting startup (A-72). */
export function useInvoices() {
  const entity = useEntity();
  const entityId = entity?.entityId;

  return useQuery({
    queryKey: billingKeys.invoices(entityId ?? 'none'),
    queryFn: () => listInvoices(entityId as string),
    enabled: Boolean(entityId),
  });
}
